(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-provider/assets/draw-hooks.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-provider/assets/draw-hooks.js');
"use strict";

const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const _React = React,
  useMemo = _React.useMemo,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport = svs.components.sport.drawsRedux.globalizedSelectors,
  selectById = _svs$components$sport.selectById,
  selectAll = _svs$components$sport.selectAll;
const selectDrawProductIds = svs.components.tipsen.engine.selectors.engineSelectors.selectDrawProductIds;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const useCurrentDraw = _drawId => {
  const drawContext = useContext(DrawContext);
  const drawId = _drawId || "".concat(drawContext === null || drawContext === void 0 ? void 0 : drawContext.productId, "_").concat(drawContext === null || drawContext === void 0 ? void 0 : drawContext.drawNumber);
  return useSelector(state => selectById(state, drawId));
};
const useCurrentDrawId = () => {
  const _useCurrentDraw = useCurrentDraw(),
    productId = _useCurrentDraw.productId,
    drawNumber = _useCurrentDraw.drawNumber;
  return "".concat(productId, "_").concat(drawNumber);
};
const useCurrentDrawEvent = drawId => {
  const _useCurrentDraw2 = useCurrentDraw(drawId),
    drawEvents = _useCurrentDraw2.drawEvents;
  const _useContext = useContext(DrawContext),
    eventNumber = _useContext.eventNumber;
  const drawEvent = useMemo(() => {
    if (eventNumber === undefined && drawEvents.length > 0) {
      return drawEvents[0];
    }
    for (const event of drawEvents) {
      if (event.eventNumber === eventNumber) {
        return event;
      }
    }
  }, [drawEvents, eventNumber]);
  return drawEvent;
};
const useDrawSearchParams = (productId, drawNumber, eventNumber, alwaysIncludeParams) => {
  const _useLocation = useLocation(),
    search = _useLocation.search;
  const qs = new URLSearchParams(search);
  const drawProductIds = useSelector(selectDrawProductIds);
  const draws = useSelector(selectAll);
  const toParams = new URLSearchParams();
  const definitionHasSingleDraw = drawProductIds.length === 1;
  const isFirstDraw = draws[0].drawNumber === drawNumber && draws[0].productId === productId;
  const includeProduct = !isFirstDraw && !definitionHasSingleDraw;
  if (includeProduct || alwaysIncludeParams) {
    toParams.set('product', productId);
  }
  if (draws[0].drawNumber !== drawNumber || alwaysIncludeParams) {
    const drawToUse = drawNumber || parseInt(qs.get('draw'), 10);
    toParams.set('draw', drawToUse);
  }
  if (alwaysIncludeParams && parseInt(qs.get('currentDraw'), 10) > 0) {
    toParams.set('currentDraw', parseInt(qs.get('currentDraw'), 10));
  }
  if (typeof eventNumber === 'number' && eventNumber !== 1) {
    toParams.set('event', eventNumber);
  }
  return toParams;
};
setGlobal('svs.components.tipsen.drawProvider.hooks', {
  useCurrentDraw,
  useCurrentDrawId,
  useCurrentDrawEvent,
  useDrawSearchParams
});

 })(window);